import { visibleRequests, type ReportRequest } from './reportRequest';

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

interface Props {
  requests: ReportRequest[] | null | undefined;
  /** 앞 요소와의 간격(예: mt-04) */
  className?: string;
}

/**
 * '✓ 요청하신 사항' — 발송 시점에 게시된 요청의 고객용 문장.
 * 읽기 전용이며 요청이 없으면 블록 자체를 그리지 않는다.
 */
export function RequestBlock({ requests, className = '' }: Props) {
  const list = visibleRequests(requests);
  if (list.length === 0) return null;
  return (
    <section className={['rounded-lg border border-border bg-surface px-04 py-03', className].join(' ')} aria-label="요청하신 사항">
      <div className="mb-02 flex items-center gap-02 text-caption font-bold text-text-secondary">
        <CheckIcon />
        요청하신 사항
      </div>
      <ul className="flex flex-col gap-03">
        {list.map((r) => (
          <li key={r.requestSnapId}>
            <p className="whitespace-pre-line break-words text-caption text-text">{r.text}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
